module.exports = __webpack_public_path__ + "img/buyTip.b9425f6f.png";